import { render, staticRenderFns } from "./MzCard.vue?vue&type=template&id=5713d046&"
import script from "./MzCard.vue?vue&type=script&lang=js&"
export * from "./MzCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports